export interface ProductItem {
  id: string;
  product_name: string;
  icon: string;
  slug: string;
}

export interface ProductCategory {
  id: string;
  title: string;
  products: ProductItem[];
}

export const productsData: ProductCategory[] = [
  {
    id: '6746ae8608b3efcbfedd1063',
    title: 'Video Plugins',
    products: [
      {
        id: '6747fa1353ed45d740942f0d',
        product_name: 'VxFX',
        icon: '/products/vxfx.png',
        slug: 'vxfx',
      },
    ],
  },
];

/**
 * Finds product ID by slug
 * @param slug - The product slug
 * @returns Product ID or null if not found
 */
export function getProductIdBySlug(slug: string): string | null {
  for (const category of productsData) {
    const product = category.products.find((p) => p.slug === slug);
    if (product) {
      return product.id;
    }
  }
  return null;
}

/**
 * Finds product slug by ID
 * @param id - The product ID
 * @returns Product slug or null if not found
 */
export function getProductSlugById(id: string): string | null {
  for (const category of productsData) {
    const product = category.products.find((p) => p.id === id);
    if (product) {
      return product.slug;
    }
  }
  return null;
}
